/* eslint-disable default-case */
import React from "react";
import { Row, Col, Tag, Tooltip, Icon } from "antd";
import Moment from "react-moment";
import styled from "styled-components";

import { UsersAssigned } from "~/components/AssignTo";
import { limitCharacterLength } from "~/utils/formatters";
import ParcelasIndicator, { summarizeInstallments, filterInstallmentsByMonth } from "./ParcelasIndicator";

export var CalendarIcon = styled(Icon).attrs({
  type: "calendar",
  style: {
    color: "black",
    marginRight: "5px",
  },
})``;

var ItemTask = styled.div`
  user-select: none;
  padding: 7px 9px;
  margin: 0 0 16px 0;
  border-radius: 3px;
  background: #fff;
  position: relative;
  border-left: 3px solid ${function(props) { return props.alert ? "#f5222d" : "transparent"; }};
  cursor: pointer;

  &:hover {
    box-shadow: 1.5px 1px 1px #ccc;
  }
`;

var ItemTaskTitle = styled.div`
  display: block;
  margin-bottom: 6px;
  font-size: 15px;
`;

var ItemId = styled.div`
  text-align: right;
  font-size: 13px;
  font-weight: bold;
`;

var ItemTaskDate = styled.div`
  font-size: 12px;
`;

var getBackgroundItem = function(category) {
  switch (parseInt(category)) {
    case 1: return "#52c41a"; // Abertura
    case 2: return "#faad14"; // Alteração
    case 3: return "#595959"; // Encerramento
    case 4: return "#1890ff"; // Tarefa
    case 5: return "#388E3C"; // Troca de Contabilidade (entrada)
    case 6: return "#722ed1"; // Outros
    case 7: return "#f5222d"; // Troca de Contabilidade (saída)
  }
};

var getTextItem = function(category) {
  switch (parseInt(category)) {
    case 1: return "Abertura";
    case 2: return "Alteração";
    case 3: return "Encerramento";
    case 4: return "Tarefa";
    case 5: return "Troca de Contabilidade";
    case 6: return "Outros";
    case 7: return "Troca de Contabilidade";
  }
};

var getInstallments = function(item) {
  if (item && item.payment && Array.isArray(item.payment.installments)) {
    return item.payment.installments;
  }
  return [];
};

export var ItemCard = function(props) {
  var item = props.item;
  var getCustomer = props.getCustomer;
  var showDrawer = props.showDrawer;
  var columnId = props.columnId;

  var installments = filterInstallmentsByMonth(getInstallments(item), props.month);
  var hasPayment = installments.length > 0;
  var isDone = columnId === "done";
  var summary = summarizeInstallments(installments, isDone);
  var isUrgent = summary ? summary.isUrgent : false;

  var customer = getCustomer(item);

  return (
    <ItemTask
      alert={isUrgent}
      onClick={function() {
        showDrawer(parseInt(item.category), {
          ...item,
          customer: getCustomer(item),
        });
      }}
    >
      <Row type="flex" justify="center" align="bottom">
        <Col span={12}>
          <ItemTaskDate>
            <CalendarIcon />
            <Moment fromNow>{item.updated_at}</Moment>
          </ItemTaskDate>
        </Col>
        <Col span={12}>
          <ItemId>#SOC{item.id}</ItemId>
        </Col>

        <Col span={24}>
          <ItemTaskTitle>
            {customer.cod ? customer.cod + " - " : ""}
            {limitCharacterLength(customer.name, 25)}
          </ItemTaskTitle>
        </Col>

        <Col span={16}>
          <Tooltip title={getTextItem(item.category)}>
            <Tag color={getBackgroundItem(item.category)} style={{ marginBottom: 6 }}>
              {getTextItem(item.category)}
            </Tag>
          </Tooltip>
        </Col>
        <Col span={8} style={{ textAlign: "right" }}>
          <UsersAssigned selectedUsers={item.custom_fields.assigned_to || []} />
        </Col>

        <Col span={24}>
          {hasPayment ? (
            <ParcelasIndicator installments={installments} isDone={isDone} />
          ) : (
            <Tooltip title="Nenhuma cobrança (serviço extra) vinculada a este ticket.">
              <span style={{ fontSize: 12, color: "#bfbfbf" }}>Cortesia</span>
            </Tooltip>
          )}
        </Col>
      </Row>
    </ItemTask>
  );
};

export default React.memo(ItemCard);
